<template>
    <div class="loan-detail-sub-table">
        <el-table :data="datas" style="width: 100%" class="row-click ah-el-data-table" v-loading="loading">
            <el-table-column prop="systemNo" label="單號" width="155">
                <template slot-scope="scope">
                    <span>{{ scope.row.systemNo }}</span>
                    <span v-if="isReserve(scope.row.repaymentDate)" class="reserved"> 預約 </span>
                </template>
            </el-table-column>
            <el-table-column prop="repaymentDate" label="還款日期" width="200">
                <template slot-scope="scope">
                    <span>{{ scope.row.repaymentDate | dateFormater("YYYY-MM-dd") }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="principalAmount" label="還款本金" align="right" min-width="150">
                <template slot-scope="scope">
                    <Money :v="scope.row.principalAmount" />
                </template>
            </el-table-column>
            <el-table-column prop="interestAmount" label="還款利息" align="right" min-width="130">
                <template slot-scope="scope">
                    <Money :v="scope.row.interestAmount" />
                </template>
            </el-table-column>
            <el-table-column prop="foO_DAT" label="扣款總額" align="right" width="130">
                <template slot-scope="scope">
                    <Money :v="scope.row.totalAmount" />
                </template>
            </el-table-column>
            <el-table-column prop="nonTaxAmt" label="扣款銀行帳戶" width="150">
                <template slot-scope="scope">
                    {{ scope.row.repaymentBankName }}
                </template>
            </el-table-column>
            <el-table-column align="center" width="80">
                <template slot-scope="scope">
                    <el-button size="small" @click="onClick(scope.row)">編輯</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick(data) {
            this.$emit('open', { type: 'edit-return', data });
        },
        isReserve(date) {
            return date > +new Date();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.reserved {
    color: red;
    font-size: 9pt;
    padding: 1px 2px;
    border-radius: 4px;
    border: 1px solid red;
}
</style>
